import { Component, ViewChild } from '@angular/core';
import { 
  Platform, 
  Nav, 
  Events, 
  MenuController, 
  ToastController,
  PopoverController 
} from 'ionic-angular';

// Pages
import { LoginPage } from '../pages/login/login';
import { DashboardPage } from '../pages/dashboard/dashboard';
import { InstructorsPage } from '../pages/instructors/instructors';
import { InstructorCandidatesPage } from '../pages/instructors/instructor-candidates';
import { ReportsPage } from '../pages/reports/reports';
import { UsersPage } from '../pages/users/users';
import { UserAccountPage } from '../pages/user-account/user-account';
import { RecertificationsPage } from '../pages/recertifications/recertifications';

// Popovers
import { UserAccountPopoverPage } from '../components/popovers/user-account.popover';

// Providers
import { HelperService } from '../providers/helpers/helper-service';

// Config 
import { Config } from '../providers/config/config';

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;

  rootPage: any;
  instructorsPage: any;
  instructorCandidatesPage: any;
  reportsPage: any;
  recertificationsPage: any;
  usersPage: any;
  userAccountPage: any;
  userApps:any = [];

  activeMenuItem: string = 'rootPage';
  showMenu: boolean = false;
  userName: string = 'User';
  userInitials: string = 'U';

  constructor(
    public platform: Platform, 
    public menuCtrl: MenuController,
    public events: Events,
    public toastCtrl: ToastController,
    public popoverCtrl: PopoverController,
    public helperService: HelperService
  ) {
    this.initializeApp();
    this.listenToEvents();

    this.instructorsPage = InstructorsPage;
    this.instructorCandidatesPage = InstructorCandidatesPage;
    this.reportsPage = ReportsPage;
    this.usersPage = UsersPage;
    this.userAccountPage = UserAccountPage;
    this.recertificationsPage = RecertificationsPage;
  }

  initializeApp()
  {
    this.platform.ready().then(() => {
      this.checkForAccessToken();
    });
  }

  menuGoTo( menuItem, page )
  {
    this.nav.setRoot( page );
    this.activeMenuItem = menuItem;
  }

  checkForAccessToken()
  {
    var access_token;
    var has_token = false;
    var token_is_valid = false;

    access_token = localStorage.getItem('access_token');

    if ( access_token !== null )
    {
      has_token = true;
      // TODO: Check to see if this is a valid token.
      token_is_valid = true;
      if ( token_is_valid === true )
      {
        Config.ACCESS_TOKEN = access_token;
        this.rootPage = DashboardPage;
        this.showMenu = true;
        this.setUserInfo();
      }
    }
    if ( !token_is_valid )
    {
      this.rootPage = LoginPage;
    }
  }

  toggleMenu()
  {
    this.menuCtrl.toggle();
  }

  listenToEvents()
  {
    // Toggle left menu open and closed
    this.events.subscribe('menu:toggle', ( logData ) => {
      this.toggleMenu();
    });

    // Log events
    this.events.subscribe('app:log', ( logData ) => {
      this.presentToast( logData );
    });

    // Is user logging in?
    this.events.subscribe('user:login', ( logData ) => {
      this.showMenu = true;
      this.setUserInfo();
    });
  }

  setUserInfo()
  {
    if ( localStorage.getItem('user') !== null )
    {
      let user = localStorage.getItem('user');
      let userObj = JSON.parse( user );
      Config.USER = user;
      this.userName = userObj.first_name;

      let fullName = userObj.first_name + ' ' + userObj.last_name;
      let initials = fullName.match(/\b\w/g) || [];
      this.userInitials = ((initials.shift() || '') + (initials.pop() || '')).toUpperCase();
      Config.USER_APPS = this.helperService.getAvailableApps( userObj );
    }  
  }

  presentToast( logData, duration = 4000, closeButtonText = 'OK' )
  {
    let toast = this.toastCtrl.create({
      message: logData.message,
      duration: duration,
      position: 'bottom',
      cssClass: 'toast-' + logData.status,
      showCloseButton: true,
      closeButtonText: closeButtonText
    });

    toast.onDidDismiss(() => {
    });

    toast.present();
  }

  logOut()
  {
    // Destroy local storage keys
    localStorage.removeItem('access_token');
    localStorage.removeItem('user');

    // Go to login page.
    this.nav.setRoot(LoginPage);
    this.showMenu = false;
  }

  presentUserPopover( ev )
  {
    let popover = this.popoverCtrl.create( UserAccountPopoverPage );
    popover.present({
      ev: ev
    });

    popover.onDidDismiss(data => {
      switch( data )
      {
        case 'log-out':
          this.logOut();
          break;
        case 'my-account':
          this.menuGoTo('userAccountPage', this.userAccountPage);
          break;
      }
    });
  }
}




// WEBPACK FOOTER //
// ./src/app/app.component.ts